import theme from '@styles/theme';
export default {
  formWrapper: {
    width: ['100%', '100%', '100%', '29.4vw'],
    height: '50px',
    display: 'block',
    margin: ['0 auto 20px', '0 auto 20px', '0 auto 20px', 'auto'],
    p: ['0 12px', '0 24px', '0 24px', '0']
  },
  inputSelect: {
    width: ['auto', 'auto', 'auto', '29.4vw'],
    m: ['0 12px', '0 24px', '0 24px', 'auto']
  },
  form: (errorMessage: string) => ({
    display: 'flex',
    position: 'relative',
    '&.error:after': {
      content: `"${errorMessage}"`,
      position: 'absolute',
      bottom: '-22px',
      color: theme.rawColors.accent700,
      fontSize: '12px',
      ml: '15px'
    }
  }),
  postCodeInput: (error: boolean) => ({
    flex: '8',
    p: '10px 15px',
    border: '1px solid',
    borderColor: error ? theme.rawColors.accent700 : theme.rawColors.lightGrey500,
    ':hover': {
      borderColor: error ? theme.rawColors.accent700 : theme.rawColors.darkGrey300
    }
  }),
  buttonSubmit: {
    flex: '1',
    height: '50px'
  }
};